var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v("Terminal registreren")]),
          _vm.unregisteredTerminals.length != 0
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-list" } },
                _vm._l(_vm.unregisteredTerminals, function (term) {
                  return _c(
                    "w-list-item",
                    {
                      key: term.id,
                      attrs: { disabled: _vm.isRegistering },
                      on: {
                        click: function ($event) {
                          return _vm.registerTerminal(term)
                        },
                      },
                    },
                    [_c("w-list-item-text", [_vm._v(_vm._s(term.toString()))])],
                    1
                  )
                }),
                1
              )
            : _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" Geen terminals beschikbaar "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Annuleren")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }